document.addEventListener("DOMContentLoaded", () => {
  const mediaQuery = window.matchMedia("(min-width: 990px)");

  let observer = null;
  let rafId = null;
  let startTime = 0;
  let boxes = [];

  const amplitude = 14; // px up/down
  const period = 6000; // longer period = slower, smoother
  const speed = (2 * Math.PI) / period;
  const smoothing = 0.08; // 0 = no smooth, 1 = instant

  function resetBoxes() {
    boxes.forEach(b => {
      b.el.style.transform = "";
      b.visible = false;
      b.lastY = 0;
    });
  }

  function tick(now) {
    const delta = now - startTime;
    boxes.forEach(b => {
      if (!b.visible) return;
      const targetY = Math.sin(delta * speed + b.phase) * amplitude;
      b.lastY += (targetY - b.lastY) * smoothing;
      b.el.style.transform = `translateY(${b.lastY.toFixed(2)}px)`;
    });
    rafId = requestAnimationFrame(tick);
  }

  function startAnimation() {
    const container = document.querySelector(".main-block-head");
    if (!container) return;

    // initialize boxes
    boxes = Array.from(container.querySelectorAll(".main-block-box1, .main-block-box2")).map((el, i) => ({
      el,
      phase: (i % 2 === 0) ? 0 : Math.PI,
      visible: false,
      lastY: 0,
    }));

    // observer to track visibility
    observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        boxes.forEach(b => {
          if (entry.target.contains(b.el)) {
            b.visible = entry.isIntersecting;
            if (!entry.isIntersecting) {
              b.el.style.transform = "";
              b.lastY = 0;
            }
          }
        });
      });
    }, { threshold: 0.2 });

    observer.observe(container);

    startTime = performance.now();
    if (rafId === null) {
      rafId = requestAnimationFrame(tick);
    }
  }

  function stopAnimation() {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
    if (rafId !== null) {
      cancelAnimationFrame(rafId);
      rafId = null;
    }
    resetBoxes();
    boxes = [];
  }

  // initial run based on current width
  if (mediaQuery.matches) {
    startAnimation();
  }

  // listen for viewport width crossing 990px
  mediaQuery.addEventListener
    ? mediaQuery.addEventListener("change", e => {
        if (e.matches) {
          startAnimation();
        } else {
          stopAnimation();
        }
      })
    : mediaQuery.addListener(e => { // fallback for older browsers
        if (e.matches) {
          startAnimation();
        } else {
          stopAnimation();
        }
      });
});
